/* Visitors from a country outside every market get the US store from Shopify (USD, "Free Shipping to USA",
   "Delivery to United States"). After the page has loaded, ask Shopify once per session for the visitor's real
   country; when it is not a market country, the US delivery options and prices stay (forwarders, gifts and
   travellers still ship to US addresses) and one line says "US addresses only — we don't ship to <country> yet."
   The announcement's "Free Shipping to USA" becomes "Free Shipping to US Addresses". Loaded only on the US store.
   US visitors, market countries, Türkiye, shoppers who picked a country in the country selector and failed
   lookups change nothing. No popup, no banner: existing text is changed in place.
   Quiet test switch, no UI: ?sa_country=BR acts as a visitor from that country for the session, ?sa_country=off
   ends it. */
(function () {
  'use strict';
  const script = document.currentScript || document.querySelector('script[data-sa-visitor-country]');
  const markets = new Set(String(script?.dataset.markets || '').split(',').filter(Boolean));
  const KEY = 'sa_visitor_country_v1';
  const PREVIEW_KEY = 'sa_country_preview_v1';
  const CHOSEN_KEY = 'sa_country_chosen_v1';
  // French, Spanish and German pages: the two lines from window.SA_I18N (snippets/sa-i18n-js.liquid), the country named in that language.
  const PROMISE = window.SA_I18N?.['visitor.promise'] ?? '🇺🇸 Free Shipping to US Addresses';
  // Orders ship from Türkiye and the owner browses from there: treated like before, never told "we don't ship".
  const HOME = new Set(['TR']);
  if (script?.dataset.country !== 'US' || !markets.has('US')) return;

  const storage = {
    get: key => { try { return sessionStorage.getItem(key); } catch { return null; } },
    set: (key, value) => { try { sessionStorage.setItem(key, value); } catch {} },
    remove: key => { try { sessionStorage.removeItem(key); } catch {} },
  };
  const regionName = code => { try { return new Intl.DisplayNames([window.SA_I18N?.date_locale || 'en'], {type: 'region'}).of(code) || code; } catch { return code; } };

  let requested = null;
  try { requested = new URL(location.href).searchParams.get('sa_country'); } catch {}
  if (requested != null) {
    const value = requested.trim().toUpperCase();
    if (value === 'OFF') storage.remove(PREVIEW_KEY);
    else if (/^[A-Z]{2}$/.test(value)) {
      storage.set(PREVIEW_KEY, value);
      // A new preview shows the line again after a test pick in the country selector.
      storage.remove(CHOSEN_KEY);
    }
  }

  // A shopper who picks a country in the selector has said where they ship: no line for the rest of the session.
  // Dawn's localization form submits with form.submit(), which fires no submit event, so the pick is the click.
  document.addEventListener('click', event => {
    const item = event.target.closest?.('localization-form a[data-value]');
    if (item?.closest('localization-form').querySelector('input[name="country_code"]')) storage.set(CHOSEN_KEY, item.dataset.value);
  }, true);
  document.addEventListener('submit', event => {
    const input = event.target.querySelector?.('[name="country_code"]');
    if (input?.value) storage.set(CHOSEN_KEY, input.value);
  }, true);
  if (storage.get(CHOSEN_KEY)) return;

  function apply(visitor) {
    if (!visitor?.code || visitor.code === 'US' || HOME.has(visitor.code) || markets.has(visitor.code)) return;
    const name = (window.SA_I18N ? '' : visitor.name) || regionName(visitor.code);
    const line = (window.SA_I18N?.['visitor.no_ship'] ?? "US addresses only — we don't ship to {country} yet.").replace('{country}', name);
    window.SpaceArmoryNoShip = {code: visitor.code, name, line};
    document.documentElement.dataset.saNoShip = visitor.code;
    const paint = () => {
      // The announcement slide is about 200px wide on a 320px phone: the full line does not fit there, this does.
      document.querySelectorAll('[data-sa-ship-promise]').forEach(node => {
        if (node.textContent !== PROMISE) node.textContent = PROMISE;
      });
      // The cart page keeps its US tax and shipping sentence, with the line above it.
      document.querySelectorAll('[data-sa-ship-note]').forEach(node => {
        const first = node.firstElementChild;
        if (first?.hasAttribute('data-sa-no-ship-line')) {
          if (first.textContent !== line) first.textContent = line;
          return;
        }
        const span = document.createElement('span');
        span.setAttribute('data-sa-no-ship-line', '');
        span.style.display = 'block';
        span.textContent = line;
        node.prepend(span);
      });
    };
    const start = () => {
      paint();
      // Dawn's cart.js rebuilds the cart page totals from the server after every quantity change.
      const footer = document.getElementById('main-cart-footer');
      if (footer) new MutationObserver(paint).observe(footer, {childList: true, subtree: true});
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
    else start();
    document.dispatchEvent(new CustomEvent('sa:visitor-country', {detail: {...window.SpaceArmoryNoShip}}));
  }

  const preview = storage.get(PREVIEW_KEY);
  if (preview) {
    apply({code: preview});
    return;
  }
  let cached = null;
  try { cached = JSON.parse(storage.get(KEY) || 'null'); } catch {}
  if (cached?.code) {
    apply(cached);
    return;
  }

  function detect() {
    fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', {credentials: 'same-origin', headers: {Accept: 'application/json'}})
      .then(response => (response.ok ? response.json() : null))
      .then(data => {
        const country = data?.detected_values?.country;
        const code = String(country?.handle || '').toUpperCase();
        const name = String(country?.name || data?.detected_values?.country_name || '');
        if (!/^[A-Z]{2}$/.test(code) || !name) return;
        storage.set(KEY, JSON.stringify({code, name}));
        apply({code, name});
      })
      .catch(() => {});
  }
  const later = () => ('requestIdleCallback' in window ? window.requestIdleCallback(detect, {timeout: 3000}) : setTimeout(detect, 1));
  if (document.readyState === 'complete') later();
  else window.addEventListener('load', later, {once: true});
})();
